import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service';

@Component({
  selector: 'app-premiumreport-summary',
  templateUrl: './premiumreport-summary.component.html',
  styleUrls: ['./premiumreport-summary.component.scss'],
  standalone: false
})
export class PremiumreportSummaryComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  direct_premium: any;
  supplemental_premium: any;
  userdefined_premium: any;
  userdefined_premium_supplemental: any;
  total_premium: any;
  premiumDataLoaded: boolean = false;
  constructor(
    private readonly submissionSummaryService: SubmissionSummaryService,
    private readonly router: Router
  ) {}
  ngOnInit(): void {
    this.loadPremiumDetails();
  }
  private loadPremiumDetails() {
    this.submissionSummaryService
      .loadPremiumDetails(this.prfNumber, this.currentYear, this.groupCode)
      .subscribe((result) => {
        if (result) {
          this.direct_premium = result.direct_premium;
          this.supplemental_premium = result.supplemental_premium;
          this.userdefined_premium = result.userdefined_premium;
          this.userdefined_premium_supplemental =
            result.userdefined_premium_supplemental;
          this.total_premium = result.total_premium;
          this.premiumDataLoaded = true;
        }
      });
  }
  navigateToPremiumData() {
    this.router.navigate([
      `/${this.currentYear}/${encodeURIComponent(
        this.prfNumber
      )}/premiumreport`,
    ]);
  }
}
